import { useContext } from 'react';
import { SocketContext } from '../context/SocketContextInstance';

export const useSocket = () => useContext(SocketContext);
